// extracted by mini-css-extract-plugin
export default {"wrapper":"LandingPage_wrapper__6babH","startWrapper":"LandingPage_startWrapper__RRq8r","button":"LandingPage_button__1HWze"};